<template>
  <transition name="panel">
    <div class="filter-panel-base" v-if="panelOpen">
      <div class="wrap">
        <div class="inner">
          <div
            class="menu-group-base"
            v-for="(group, gidx) in filterInfoList"
            :key="`g${gidx}`"
            @click.stop="onGroupHeadClick(gidx)"
          >
            <div class="group-wrap">
              <div class="menus-head" :class="{open: group.open}">
                <span class="title">{{ group.menuLabel }}</span>
                <span class="selected">{{ group.selected }}</span>
              </div>
              <transition name="group">
                <div class="menus-wrap" v-if="group.open">
                  <div class="menu-items" @click.stop="onFilterUnsetClick(gidx)"><span class="inner">未設定</span></div>
                  <div
                    class="menu-items"
                    v-for="(menu, midx) in group.lists"
                    :key="`m${midx}`"
                    @click.stop="onMenuItemClick(gidx, menu)"
                  ><span class="inner">{{ menu.lavel }}</span></div><!-- タイポ、、、 -->
                </div>
              </transition>
            </div>
          </div>
        </div>
        <div class="submit-area">
          <sec-button-link
            :no-border="true"
            button-face="検索する"
            :btn-disable="!(this.selectedArr.length > 0 || (this.selectedArr.length === 0 && this.selectedCache.length > 0))"
            @link-click="onSubmitClick"
          />
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import _ from 'lodash'
import * as type from '@/utvStore/store/mutation-types'
import SecButtonLink from '@/utvStore/components/partials/SecButtonLink'

const MENUS_LIST = [
  { key: 'category', label: 'カテゴリ', menuLabel: 'カテゴリで探す', },
  { key: 'counselor', label: '占い師', menuLabel: '占い師で探す', },
  { key: 'divination', label: '占い方', menuLabel: '占い方で探す', },
]

export default {
  name: 'FilterPanels',
  components: {
    SecButtonLink,
  },
  data() {
    return {
      filterData: [],
      selectedArr: [],
      selectedCache: [],
    }
  },
  props: {
    tagId: {
      type: String,
      default: ''
    },
    userId: {
      type: Number,
      defaul: -1
    },
    accessToken: {
      type: String,
      default: '',
    },
    panelOpen: {
      type: Boolean,
      default: false,
    },
    filterInfo: {
      type: Object,
      default() {
        return false
      }
    },
    resetTrigger: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    filterInfoList: {
      get() {
        const arr = []
        if(this.filterData.length === 0){
          for (const item of MENUS_LIST) {
            if(item.key in this.filterInfo && this.filterInfo[item.key].length > 0){
              arr.push({
                ...item,
                open: false,
                selected: '',
                lists: this.filterInfo[item.key]
              })
            }
          }
          this.filterData = arr
        }
        return this.filterData
      },
      set(val) {}
    },
  },
  watch: {
    panelOpen(val){
      if(val){
        //開くとき
        if(Object.keys(this.selectedCache).length > 0){
          this.selectedCache.forEach(item => {
            const tgt = this.filterInfoList.find(grp => {
              if(grp.key === item.key){
                grp.selected = item.label
              }
              grp.open = false
            })
          })
        } else {
          this.filterInfoList.forEach(grp => {
            grp.selected = ''
            grp.open = false
          })
        }
        this.selectedArr = _.cloneDeep(this.selectedCache)
      }
    },
    /*
    resetTrigger(val){
      //結局つかわなそう
      console.log('resetTriger[%s]', val)
    }
     */
  },
  mounted() {
    dbg.info('-- filterInfo:%O', this.filterInfo)
    dbg.info('-- filterInfoList:%O', this.filterInfoList)
  },
  methods: {
    onGroupHeadClick(val) {
      // console.log('group head click[%s] %O', val, this.filterInfoList[val])
      this.filterInfoList[val].open = !this.filterInfoList[val].open
    },
    onMenuItemClick(gidx, dt) {
      const tgtDt = this.filterInfoList[gidx]
      tgtDt.selected = dt.lavel
      tgtDt.open = false
      const storeDt = this.selectedArr.find(item => item.key === tgtDt.key)
      if(!storeDt){
        this.selectedArr.push({ key: tgtDt.key, id: +dt.id, label:dt.lavel })
      }else{
        storeDt.id = +dt.id
        storeDt.label = dt.lavel
      }
      // console.log('menuItem click[%s:%s] %O selectedArr:%O', gidx, dt.lavel, dt, this.selectedArr)
    },
    onSubmitClick(){
      if(!!(+this.tagId)){
        const list = this.selectedArr.length > 0 ? this.selectedArr : []
        this.$emit('set-loading')
        this.$emit('close-panel')
        this.$store.dispatch( type.GET_FILTERED_TAG_ITEMS, {
          tagId: this.tagId,
          userId: this.userId,
          accToken: this.accessToken,
          lists: list,
        })
        this.selectedCache = _.cloneDeep(this.selectedArr)
      }
    },
    onFilterUnsetClick(gidx){
      const tgtDt = this.filterInfoList[gidx]
      tgtDt.selected = ''
      tgtDt.open = false
      this.selectedArr = this.selectedArr.filter(item => item.key !== tgtDt.key)
    },
  }
}</script>

<style scoped lang="scss">
@import "../../../../sass/commons/commonVariables.scss";
.filter-panel-base {
  background: white;
  z-index: 91000;
  position: absolute;
  //top: 80px;
  width: 100%;
  height: calc(100% - 62px);
  max-width: 580px;
  .wrap {
    width: 100%;
    height: 100%;
    position: relative;
    .inner {
      height: 100%;
      overflow-y: auto;
      overflow-x: hidden;
      padding-bottom: 200px;
    }
  }
  .menu-group-base {
    width: 100%;
    cursor: pointer;
    &:first-child {
      border-top: 1px solid #dcdfe2;
    }
    .group-wrap {
      .menus-head {
        line-height: 1;
        height: 60px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #dcdfe2;
        padding: 0 48px 0 20px;
        position: relative;
        .title {
          font-size: 18px;
        }
        .selected {
          color: $col_temp_key1;
        }
        &::after {
          content: "";
          background: url('/static/img/common/arrow_right.svg') no-repeat right center;
          background-size: auto 24px;
          position: absolute;
          width: 24px;
          height: 24px;
          display: inline-block;
          right: 12px;
          top: 0;
          bottom: 0;
          margin: auto;
          transform: rotate(90deg);
          transition: transform 200ms ease-out 0s;
        }
        &.open {
          &::after {
            transform: rotate(-90deg);
          }
        }
      }
      .menus-wrap {
        .menu-items {
          padding: 0 20px;
          background: #f5f7fa;
          .inner {
            display: flex;
            align-items: center;
            width: 100%;
            font-size: 16px;
            border-bottom: 1px solid #dcdfe2;
            height: 60px;
            padding: 0;
          }
        }
      }
    }
  }
  .submit-area {
    background: white;
    position: absolute;
    bottom: 0;
    /deep/ .button-link-base {
      padding: 20px 0;
    }
  }
}
.panel {
  &-enter-active,
  &-leave-active {
    transition: all 200ms ease-out 0s;
  }
  &-enter, &-leave-to {
    transform: translate(0, -20px);
    opacity: 0;
  }
  &-enter-to, &-leave {
    transform: translate(0, 0);
    opacity: 1;
  }
}
.group {
  &-enter-active,
  &-leave-active {
    transition: all 200ms ease-out 0s;
  }
  &-enter, &-leave-to {
    transform: translate(0, -20px);
    opacity: 0;
  }
  &-enter-to, &-leave {
    transform: translate(0, 0);
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Playlist/FilterPanels.vue